import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '@/redux-config/entities/user';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { RoleApi } from '@/api';
import { CustomBreadCrumb } from '@/components/customBreadCrumb';
import { PermissionType } from '@/DTO';
import Swal from 'sweetalert2';
import { Loading } from '@/components';

export const EditRolesPage: React.FC<{}> = () => {
  const user = useSelector(selectUser);
  const { id } = useParams();
  const [permissionsList, setPermissionsList] = useState<PermissionType[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedPermissionsId, setSelectedPermissionsId] = useState<string[]>(
    [],
  );
  const [isAllCheck, setIsAllCheck] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const navigate = useNavigate();

  const { t } = useTranslation();

  const crumbs = [
    { name: 'Dashboard', href: '/' },
    { name: 'Role list', href: '/roles' },
    { name: 'Edit ', href: '#' },
  ];

  const fetchRoleID = () => {
    if (id) {
      RoleApi.GetRoleById(user, id)
        .then((data) => {
          setLoading(false);
          setName(data.data.title + '');
          const list: string[] = [];
          data?.data?.permission_list &&
            data?.data?.permission_list?.map((mainItem) => {
              list.push(mainItem);
            });

          setSelectedPermissionsId(list);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchApi();
    fetchRoleID();
  }, []);

  useEffect(() => {
    const allList = handleGetAllPermissionId();
    if (
      allList.length === selectedPermissionsId.length &&
      selectedPermissionsId.length !== 0
    ) {
      setIsAllCheck(true);
    } else {
      setIsAllCheck(false);
    }
  }, [selectedPermissionsId]);

  const fetchApi = () => {
    setLoading(true);
    RoleApi.GetPermissionList(user)
      .then((data) => {
        setPermissionsList(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleCheckBoxChange = (id: string) => {
    if (selectedPermissionsId.indexOf(id) >= 0) {
      let list: string[] = selectedPermissionsId;
      const deleteList = list.filter((data) => data != id);
      setSelectedPermissionsId(deleteList);
    } else {
      setSelectedPermissionsId([...selectedPermissionsId, id]);
    }
  };

  const handleGetAllPermissionId = (): string[] => {
    let list: string[] = [];
    for (var i = 0; i < permissionsList.length; i++) {
      var permissions = permissionsList[i].permission_list;
      for (var j = 0; j < permissions.length; j++) {
        var id = permissions[j];
        list.push(id);
      }
    }
    return list;
  };

  const handleAllClick = () => {
    let list = handleGetAllPermissionId();
    if (
      list.length !== selectedPermissionsId.length ||
      selectedPermissionsId.length === 0
    ) {
      setSelectedPermissionsId(list);
    } else {
      setSelectedPermissionsId([]);
    }
  };

  const handleIsCheck = (id: string): boolean => {
    if (selectedPermissionsId.indexOf(id) >= 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleCreateNewRoles = () => {
    setLoading(true);

    RoleApi.EditRole(user, id + '', name, selectedPermissionsId)
      .then((data) => {
        setLoading(false);
        Swal.fire({
          text: 'Your Role was changed',
          icon: 'success',
        }).then(() => {
          navigate('/roles');
        });
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>{t('gbars')} | New Role</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <></>
      )}
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        <div className="d-flex flex-column bg-custom-white rounded mt-2 p-3">
          <div className="d-flex flex-row justify-content-between align-items-center mb-4">
            <div className="d-flex flex-row flex-wrap">
              <label
                className="mx-2 d-flex flex-column"
                style={{ minWidth: '230px' }}
              >
                <strong className="mb-0">{t('Name')}</strong>
                <input
                  disabled={name === 'Coach'}
                  className={'border-reg rounded-2'}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  value={name}
                />
              </label>
            </div>
            <label className="d-flex flex-row justify-content-between">
              <span style={{ cursor: 'pointer' }}>Select All</span>
              <input
                name="group1"
                type={'checkbox'}
                className="mx-2"
                id={'selectAll'}
                onChange={() => {
                  handleAllClick();
                  setIsAllCheck(!isAllCheck);
                }}
                checked={isAllCheck}
              />
            </label>
          </div>
          <div className="d-flex flex-row flex-wrap ">
            {permissionsList.map((item, index) => (
              <div
                className="d-flex flex-column col-12 col-md-6 col-lg-4 p-2"
                key={index}
              >
                <strong>{item.group}</strong>
                <ul className="d-flex flex-column gap-1">
                  {item?.permission_list &&
                    item?.permission_list.map((data, index) => (
                      <li key={index}>
                        <label className="d-flex flex-row justify-content-between">
                          <span
                            style={{
                              cursor: 'pointer',
                            }}
                          >
                            {data}
                          </span>
                          <input
                            name="group1"
                            type={'checkbox'}
                            id={String(data)}
                            onChange={(e) => {
                              handleCheckBoxChange(data ? data : '0');
                            }}
                            checked={handleIsCheck(data ? data : '0')}
                          />
                        </label>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="d-flex flex-row justify-content-end">
            <button
              disabled={selectedPermissionsId.length <= 0 || name.length <= 1}
              onClick={() => {
                handleCreateNewRoles();
              }}
              className={'btn prm-btn'}
            >
              {t('submit')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
